module.exports = __webpack_public_path__ + "img/appoints.eb6bee48.png";